<template>
  <portal to="breadcrumb-right">
    <nav
      v-if="availableTabs.length"
      aria-label="Visões de contratos"
      class="contract-report-tabs"
    >
      <router-link
        v-if="canReadContracts"
        :to="{ name: 'contracts-list' }"
        class="contract-report-tab"
        :class="{ active: $route.name === 'contracts-list' }"
      >
        <feather-icon
          icon="FileTextIcon"
          size="15"
        />
        <span>Contratos</span>
      </router-link>
      <router-link
        v-for="tab in availableTabs"
        :key="tab.key"
        :to="{ name: 'bi-report-view', params: { key: tab.key } }"
        class="contract-report-tab"
        :class="{ active: $route.name === 'bi-report-view' && $route.params.key === tab.key }"
      >
        <feather-icon
          :icon="tab.icon"
          size="15"
        />
        <span>{{ tab.label }}</span>
      </router-link>
    </nav>
  </portal>
</template>

<script>
import { mapActions } from 'vuex'
import { CONTRACT_REPORT_TABS } from '@/constants/contract_report_tabs'
import {
  READ_ACTION, CONTRACT_RESOURCE, BI_REPORTS_MENU, BI_REPORTS_PN_MENU,
} from '@/constants/resources'
import { GET_BI_REPORTS } from '@/modules/shared/store/types'

export default {
  props: {
    reports: { type: Array, default: null },
  },
  data() {
    return { fetchedReports: [] }
  },
  computed: {
    canReadContracts() {
      return this.$can(READ_ACTION, CONTRACT_RESOURCE)
    },
    canReadBi() {
      return this.$can(READ_ACTION, BI_REPORTS_MENU) || this.$can(READ_ACTION, BI_REPORTS_PN_MENU)
    },
    availableTabs() {
      if (!this.canReadBi) return []
      const catalog = this.reports || this.fetchedReports
      const reports = Array.isArray(catalog) ? catalog : []
      return CONTRACT_REPORT_TABS.filter(tab => reports.some(report => report.key === tab.key))
    },
  },
  created() {
    if (this.reports === null && this.canReadBi) {
      this.getBiReports().then(reports => { this.fetchedReports = reports }).catch(() => {
        // A listagem de contratos continua disponível se o catálogo falhar.
        this.fetchedReports = []
      })
    }
  },
  methods: {
    ...mapActions({ getBiReports: GET_BI_REPORTS }),
  },
}
</script>

<style lang="scss">
// Sem `scoped`: o conteúdo é renderizado pelo portal-target do AppBreadcrumb,
// fora da árvore deste componente.
.contract-report-tabs {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.286rem;
  background-color: #fff;
  border: 1px solid #ebe9f1;
  border-radius: 0.428rem;
  max-width: 100%;
  overflow-x: auto;
}

.contract-report-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.9rem;
  border-radius: 0.358rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: #6e6b7b;
  white-space: nowrap;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    color: #f26237;
  }

  &.active {
    background-color: rgba(242, 98, 55, 0.12);
    color: #f26237;
    font-weight: 600;
  }
}

.dark-layout {
  .contract-report-tabs {
    background-color: #283046;
    border-color: #3b4253;
  }

  .contract-report-tab {
    color: #b4b7bd;
  }
}
</style>
